import axios from "./http";
import store from "@/store/index";
let module = "/sysFile";

let baseURL = ""
if (process.env.NODE_ENV == 'development') {
  baseURL = 'http://127.0.0.1:8080';
} else if (process.env.NODE_ENV == 'test') {
  baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
  baseURL = 'http://127.0.0.1:8080';
}


async function fileUpload(formData) {
  let data = {};
  if (!formData.has('filePath')) {
    formData.append('filePath', 'default');
  }
  data = await axios.post(module + '/fileUpload', formData, {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.flag) {
      if (res.flag) {
        return res.obj
      }
    }
  })
  return data
}
function fileDownload(fileId){
  return baseURL+module+"/fileDownload/"+fileId+"?token="+store.state.token
}

export default {
  fileUpload,fileDownload
}



// WEBPACK FOOTER //
// ./src/api/file.js